import { Component, Input } from '@angular/core';
import { Language } from '../../models/language.model';
import { CommonModule } from '@angular/common';
import { FilterAllPipe } from '../../pipes/filter-all.pipe';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { ModalController } from '@ionic/angular';
import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  IonButtons,
  IonIcon
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { close } from 'ionicons/icons';

@Component({
  selector: 'app-language-selection-modal',
  templateUrl: './language-selection-modal.component.html',
  styleUrls: ['./language-selection-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FilterAllPipe,
    TranslatePipe,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonGrid,
    IonRow,
    IonCol,
    IonButton,
    IonButtons,
    IonIcon
  ]
})
export class LanguageSelectionModalComponent {
  @Input() availableLanguages: Language[] = [];
  @Input() selectedLanguages: Language[] = [];

  constructor(private modalController: ModalController) {
    addIcons({ close });
  }

  closeLanguageModal() {
    this.modalController.dismiss({
      selectedLanguages: this.selectedLanguages
    });
  }

  selectLanguage(lang: Language) {
    const index = this.selectedLanguages.findIndex(l => l.value === lang.value);
    if (index > -1) {
      this.selectedLanguages.splice(index, 1);
    } else {
      this.selectedLanguages.push(lang);
    }
  }

  isLanguageSelected(lang: Language): boolean {
    return this.selectedLanguages.some(l => l.value === lang.value);
  }
}